/**
 * 包含多个简介更新state的方法，对象模块
 * */
import { USER_INFO, INIT_SHOP_CART, SET_LOGIN ,SET_ROUND} from './mutations-type'

export default {
    // 同步用户信息
    setUserInfo({ commit }, v) {
        commit(USER_INFO, v)
    },
    setInitShopCart({ commit }, v) {
        commit(INIT_SHOP_CART, v)
    },
    isLogin({ commit }, v) {
        commit(SET_LOGIN, v)
    },
    setRound({ commit }, v){
        commit(SET_ROUND,v)
    }
}


// WEBPACK FOOTER //
// ./src/store/actions.js